import { render, staticRenderFns } from "./MarketingPage.vue?vue&type=template&id=60eea416"
import script from "./MarketingPage.vue?vue&type=script&lang=js"
export * from "./MarketingPage.vue?vue&type=script&lang=js"
import style0 from "./MarketingPage.vue?vue&type=style&index=0&id=60eea416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports